import { useNotification } from '@/contexts/WebsocketProvider/Notification.provider';
import { ChatAPIStatus } from '@/core/domain/chat-api/tasks/tasks.types';
import { UserNotificationOriginEnum } from '@/core/domain/communication/userNotification/userNotification.types';
import { notification, Divider } from 'antd';
import { Group } from 'antd/lib/avatar';
import { useEffect } from 'react';

type HandleFeedback = (
  status: ChatAPIStatus,
  notificationId: number,
  metadata?: string,
  onCallback?: VoidFunction,
) => void;

export function useBitrixNotification(handleFeedback: HandleFeedback) {
  const { userNotification } = useNotification();

  useEffect(() => {
    if (
      userNotification &&
      userNotification.origin ===
        UserNotificationOriginEnum.BITRIX_TASK_COMPLETED &&
      userNotification.metadata
    ) {
      notification.info({
        key: UserNotificationOriginEnum.BITRIX_TASK_COMPLETED,
        duration: null,
        message: userNotification.message,
        description: (
          <>
            <span>{userNotification.description}</span>
            <Group style={{ marginTop: 10 }}>
              <a
                style={{ fontWeight: 600 }}
                onClick={(e) => {
                  e.preventDefault();
                  handleFeedback(
                    ChatAPIStatus.FEEDBACK_SUCCESS,
                    userNotification.notificationId,
                    userNotification.metadata,
                    () =>
                      notification.close(
                        UserNotificationOriginEnum.BITRIX_TASK_COMPLETED,
                      ),
                  );
                }}
              >
                Chamado resolvido
              </a>
              <Divider type="vertical" />
              <a
                style={{ fontWeight: 600, color: 'gray' }}
                onClick={(e) => {
                  e.preventDefault();
                  handleFeedback(
                    ChatAPIStatus.FEEDBACK_ERROR,
                    userNotification.notificationId,
                    userNotification.metadata,
                    () =>
                      notification.close(
                        UserNotificationOriginEnum.BITRIX_TASK_COMPLETED,
                      ),
                  );
                }}
              >
                Não resolvido
              </a>
            </Group>
          </>
        ),
      });
    }
  }, [userNotification]);
}
